import * as angular from "angular";
import { playService } from "../services/app";
import { RegionPageController } from "./RegionPage";
import { RegionSuggestionService } from "./RegionSuggestionService";

export let playRegion = angular.module("play.region", [playService.name]);

playRegion.factory("RegionSuggestionService", RegionSuggestionService);
playRegion.controller("RegionPageCtrl", RegionPageController as any);
